import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Server } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export function LoginPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate('/', { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-0">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-0 p-4">
      <div className="w-full max-w-sm">
        <div className="rounded-2xl border border-surface-300 bg-surface-100 p-8 shadow-xl">
          {/* Logo & Title */}
          <div className="mb-8 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-brand-600/15">
              <Server className="h-7 w-7 text-brand-400" />
            </div>
            <h1 className="text-xl font-semibold text-neutral-100">Webhosting Portal</h1>
            <p className="mt-1 text-sm text-neutral-500">
              Melden Sie sich an, um fortzufahren
            </p>
          </div>

          {/* SSO Login Button */}
          <a
            href="/api/v1/auth/login"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-surface-100"
          >
            Mit SSO anmelden
          </a>

          <p className="mt-6 text-center text-xs text-neutral-600">
            Authentifizierung über Authentik SSO
          </p>
        </div>
      </div>
    </div>
  );
}
